<script>
import { useModals } from 'frontend/common/modals'
import { Osl } from 'frontend/osls'

export default {
  name: 'TransportBookingVersionOsl',
  props: {
    versionItem: { type: Object, default: () => ({}) },
  },
  setup() {
    return { ...useModals() }
  },
  components: {
    Osl,
  },
}
</script>

<template lang="pug">
.d-flex.align-items-center.justify-content-start(v-if="versionItem.operationalServiceLevel")
  i.bi-info-circle.text-info.me-2(
    v-if="versionItem.objectChanges?.lockedOslAssignment?.[0]"
    v-tooltip="`OSL was manually overridden so it won't be managed via batch actions`"
  )
  osl(:osl="versionItem.operationalServiceLevel")
.bold.text-warning(v-else) No service
</template>
